import { gsap } from "gsap/dist/gsap";

export default function platformAnimation(platformTl) {
  const platformLogoArray = gsap.utils.toArray(".platform-logo-text");
  platformTl.from(platformLogoArray, {
    stagger: 0.2,
    opacity: 0,
  });
}
